import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ReactSVG } from 'react-svg';

import { InnerContent } from '../../../modules/editor';
import { RootState } from '../../../modules';
import Select from '../../../components/Dropdown/Select';
import ButtonGroup from '../../../components/Button/ButtonGroup';
import ButtonToggleValue from '../../../components/Button/ButtonToggleValue';
import ColorPicker from '../../../components/ColorPicker/ColorPicker';
import MergeDropDown from '../../../components/Merge/MergeDropDown';
import EmojiPicker from '../../../components/Emoji/EmojiPicker';

import ButtonModal from '../../../components/Button/ButtonModal';
import useAlert from '../../../hooks/useAlert';
import { getPathAfterBuild } from '../../../util/file';

type Props = {
	innerContent: InnerContent;
	style: any;
	contentId: number;
	contentIndex: number;
	subIndex?: number;
};

function CtaToolbar({ innerContent, style, contentId, contentIndex, subIndex }: Props) {
	const dispatch = useDispatch();
	const Alert = useAlert();

	const iconImage = (path) => {
		const context = require.context('../../../assets/images/', true);
		return getPathAfterBuild(context, path);
	};

	const editor = useSelector((state: RootState) => state.editor);	

	const contentTarget = subIndex === undefined ? `${contentId}/content/${contentIndex}` : `${contentId}/content/${contentIndex}/${subIndex}`;
	const styleTarget = subIndex === undefined ? `${contentId}/style/${contentIndex}` : `${contentId}/style/${contentIndex}/${subIndex}`;

	const isDonation = innerContent.buttonLink?.includes('donus.org');
	
	return (
		<div className="toolbar cta">
			<div className="group first">
				<Select
					target={`${styleTarget}/button/buttonType`}
					value={style?.buttonType}
					options={editor.option.buttonType}
					size="small"
				/>
				<span className="divide" />
				<ColorPicker
					target={`${styleTarget}/button/background`}
					value={style?.background}
					showValueText={false}
					showLabel={true}
					labelText="배경 색상"
				>배경 색상</ColorPicker>				
				<span className="divide" />
				<span className="inline-label">
					테두리
				</span>		
				<Select
					target={`${styleTarget}/button/borderWidth`}
					value={style?.borderWidth}
					options={editor.option.borderWidth}
					size="small"
				/>
				<ColorPicker
					target={`${styleTarget}/button/borderColor`}
					value={style?.borderColor}
					showValueText={false}
					showLabel={false}
				/>
			</div>
			<div className="group ">
				<Select
					target={`${styleTarget}/button/fontFamily`}
					value={style?.fontFamily}
					options={editor.option.fontFamily}
					size="tiny"
				/>
				<span className="divide" />
				<Select
					target={`${styleTarget}/button/fontSize`}
					value={style?.fontSize}
					options={editor.option.fontSize}
					size="tiny"
				/>
				<span className="divide" />
				<ColorPicker
					target={`${styleTarget}/button/color`}
					value={style?.color}
					showValueText={false}
					showChip={false}
					showLabel={false}
					showChildren={true}
					position="right"
				>
					<span className="text-color">
						<ReactSVG src={iconImage(`./icon/toolbar/text.svg`)} width="10" />
						<div 
							className="text-color-bar"
							style={{ backgroundColor: style?.color }}
						></div>
					</span>
				</ColorPicker>
				<span className="divide" />
				<div className="btn-group">
					<ButtonModal
						target={`${contentTarget}`}
						value={innerContent}
						valueType="url"
						name="buttonLink"
						imagePath="icon/toolbar/link"
						imageType="svg"
						title="URL을 입력하세요"
					/>
				</div>
				{!isDonation && (
					<div className="btn-group">
						<ButtonToggleValue
							target={`${contentTarget}/buttonLink`}
							value=""
							name=""
							imagePath="icon/toolbar/unlink"
							imageType="svg"
							confirmText={Alert?.msg?.UNLINK_CTA}
						/>
					</div>
				)}
				<span className="divide" />
				
				<MergeDropDown 
					target={`${contentTarget}/buttonText`}
					value={innerContent?.buttonText || ''}
				/>
				
				<EmojiPicker 
					target={`${contentTarget}/buttonText`}
					value={innerContent?.buttonText || ''}
				/>
				
				<span className="divide" />
				<div className="btn-group">
					<ButtonToggleValue
						target={`${styleTarget}/button/fullWidth`}
						value={style.fullWidth}
						name="wide"
						imagePath="icon/toolbar/cta_"
						imageType="svg"
					/>
				</div>
				<span className="divide" />
				<ButtonGroup
					target={`${styleTarget}/button/textAlign`}
					value={style.textAlign}
					options={editor.option.ctaAlign}
					imagePath="icon/toolbar/button_align_"
					imageType="svg"
				/>
			</div>
		</div>
	);
}

export default CtaToolbar;